// extracted by mini-css-extract-plugin
export default {"root":"TopicEmpty_root__eDMlg","add":"TopicEmpty_add__smZD4"};